module.exports = __webpack_public_path__ + "static/media/logo-icon.b53bc9b2.svg";